<template>
    <div class="confirmation-button-wrapper clearfix" :style="'max-width:' + maxWidth + 'px;'">
        <transition name="slide">
            <div v-if="isButtonActive == true" class="btn-group btn-confirm-delete">
                <div v-if="confirmationLabel === ''" :class="themeStyle" @click="handleConfirmationClick"><i class="fa fa-check" aria-hidden="true"></i></div>
                <div v-else :class="themeStyle" @click="handleConfirmationClick">{{ confirmationLabel }}</div>

                <div v-if="cancelLabel === ''" :class="outlineThemeStyle" @click="handleCancelClick"><i class="fa fa-times" aria-hidden="true"></i></div>
                <div v-else :class="outlineThemeStyle" @click="handleCancelClick">{{ cancelLabel }}</div>
            </div>
            <button v-if="isButtonActive == false" style="border-left: none !important;width: 100%;" :class="themeStyle" class="btn-start-confirmation" @click="handleInitialClick"><span>{{ actionLabel }}</span></button>
        </transition>
    </div>
</template>

<script>
export default {
    /*

    Description:
    A button that when clicked asks the user to confirm or cancel clicking of the button. Generally to be used for dangerous actions.

    Props:
    action-label (String) : the initial label displayed on the button. Defaults to 'Action'.
    confirmation-label (String) : the label used to confirm action. Defaults to a checkmark graphic.
    cancel-label (String) : the label used to cancel the action. Defaults to a 'X' graphic.
    bootstrap-theme (String) : support values are 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'. Defaults to 'primary'.
    max-width (Number) : maximum width of the button. Defaults to 180px.

    Emitted:
    action-clicked : emitted when the user confirms button action
    action-canceled : emitted when the user cancels button action

    */
    name: 'confirmation-button',
    props: {
        bootstrapTheme: {
            type: String,
            default: 'primary'
        },
        actionLabel: {
            type: String,
            default: 'Action'
        },
        confirmationLabel: {
            //default conformation label is a check mark. Can be overridden with a string
            type: String,
            default: ''
        },
        cancelLabel: {
            //default cancel label is a 'X' mark. Can be overridden with a string
            type: String,
            default: ''
        },
        maxWidth: {
            type: Number,
            default: 180

        }
    },
    data() {
        return {
            isButtonActive: false
        }
    },
    computed: {
        themeStyle() {
            let style = {
                'btn': true,
                [`btn-${this.bootstrapTheme}`]: true

            }

            return style;
        },
        outlineThemeStyle() {
            let style = {
                'btn': true,
                [`btn-outline-${this.bootstrapTheme}`]: true

            }

            return style;
        },
    },
    methods: {
        handleInitialClick() {
            this.isButtonActive = true;
        },
        handleConfirmationClick() {
            this.isButtonActive = false;
            this.$emit('action-clicked');
        },
        handleCancelClick() {
            this.isButtonActive = false;
            this.$emit('action-canceled');
        }
    }
}
</script>

<style scoped lang="scss">
    .confirmation-button-wrapper {
        position: relative;
        border-left: 1px solid #f5f6fa;
        overflow: hidden;
        height: 38px;
        width: 33.33%;
        border-radius: 2px;
        .btn-confirm-delete, .btn-start-confirmation{
            position: absolute;
            width: 100%;
            top: 0;
        }
    }
    .btn-confirm-delete{
        width: 100%;
        .btn{
            width: 100%;
            padding: 11px 8px 9px 8px;
        }
    }
    .slide-reverse-leave-active,
    .slide-reverse-enter-active,
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(-100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(100%, 0);
    }
    .slide-reverse-enter {
      transform: translate(100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-reverse-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(-100%, 0);
    }
</style>